<template>
  <v-app>
    <component :is="layout"/>
    <im-snk-bar/>
  </v-app>
</template>

<script>
  export default {

    data: () => ({}),

    created() {
      this.$moment.locale('ro');
    },

    components: {
      'authentication-layout': () => import('./layouts/AuthenticationLayout'),
      'application-layout': () => import('./layouts/ApplicationLayout'),
      'im-snk-bar': () => import('@/components/TheSnackBar')
    },

    computed: {
      layout() {
        if (this.$route.meta.private_route === false)
          return 'authentication-layout';

        if (this.$route.meta.private_route === true)
          return 'application-layout';
      }
    }

  };
</script>
